// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vx-auth-form{width:100%;margin:0 auto;padding:0 4rem;max-width:500px}.vx-auth-form .vx-form{width:100%}.vx-auth-form__action{margin-top:2rem;width:100%}.vx-auth-form__info-text{margin-top:1rem;font-size:1.4rem}\n", ""]);
// Exports
module.exports = exports;
